import React, { useState, useContext, useEffect } from "react";
import axios from 'axios';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import de from "date-fns/locale/de";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'


import { Paper, Button, Box, TextField, InputAdornment, Tooltip } from "@material-ui/core";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import SearchIcon from '@material-ui/icons/Search';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ArchiveIcon from '@material-ui/icons/Archive';
import BarChartIcon from '@material-ui/icons/BarChart';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';

import { capitalize } from "../../functions/GlobalHelpers"
import ArchiveStatsDialog from "./tools/ArchiveStatsDialog";


const useStyles = makeStyles((theme) => ({
  creditRow: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  inactiveCreditRow: {
    opacity: 0.55,
  },
  inactiveProfileHint: {
    marginLeft: theme.spacing(1),
  },
  filterBar: {
    marginBottom: theme.spacing(2)
  }
}));

const CreditsList = (props) => {
  const theme = useTheme();
  const classes = useStyles();
  let history = useHistory();
  const userContext = useContext(UserContext);
  const pageContext = useContext(PageContext);
  const [actionsMenuTarget, setActionsMenuTarget] = useState(null);
  const [creditForActions, setCreditForActions] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [agentFilter, setAgentFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [subtypeFilter, setSubtypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [fixzinsEndDateFromFilter, setFixzinsEndDateFromFilter] = useState(null);
  const [fixzinsEndDateToFilter, setFixzinsEndDateToFilter] = useState(null);

  const [aufschlagVariabelFromFilter, setAufschlagVariabelFromFilter] = useState("");
  const [aufschlagVariabelToFilter, setAufschlagVariabelToFilter] = useState("");
  const [archiveStatsOpen, setArchiveStatsOpen] = useState(false);



  const setCreditStatus = (status) => {
    const stats = creditForActions.stats;
    // remove null properties from stats
    Object.keys(stats).forEach(key => {
      if (stats[key] === null) {
        delete stats[key];
      }
    });
    const saveData = { ...creditForActions, stats: stats, status: status };

    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/credits/${creditForActions.id}`,
      data: saveData,
      method: 'put',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        props.getCredits();
        if (status === "archived" || status === "successful") {
          pageContext.setInfoMessage("Finanzierung wurde archiviert. Du findest sie rechts oben im Archiv-Tab.");
        } else {
          pageContext.setInfoMessage("Finanzierung wurde aus dem Archiv reaktiviert.");
        }
      })
      .catch((err) => {
        console.log(err);
        if (status === "archived" || status === "successful") {
          pageContext.setErrorMessage("Finanzierung konnte nicht archiviert werden!");
        } else {
          pageContext.setErrorMessage("Finanzierung konnte nicht reaktiviert werden!");
        }
      });
  }


  const renderCredit = (credit) => {
    const isInactiveAdvisor = credit.user && credit.user.active === false;
    // Finanzierung wurde an Berater übergeben und Tippgeber hat keinen Zugriff mehr
    if (userContext.user.role === "tippgeber" && userContext.user.ID !== credit.user.id) {
      return <Paper key={credit.id} className={`${classes.creditRow} ${isInactiveAdvisor ? classes.inactiveCreditRow : ""}`}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={8} md={6}>
            <Typography className={classes.heading}>
              {credit.title}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {credit.type === "konsum" ? "Konsumkredit" : "Hypothekarkredit"}
              {credit.subtype && " - " + capitalize(credit.subtype)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="overline">
              Finanzierungsberater:{" "}
              {credit.user.name}
              {isInactiveAdvisor && (
                <span className={classes.inactiveProfileHint}>inaktives Profil</span>
              )}
            </Typography>
          </Grid>
        </Grid>
      </Paper>;
    }

    // alle anderen Fälle
    return <Paper key={credit.id} className={`${classes.creditRow} ${isInactiveAdvisor ? classes.inactiveCreditRow : ""}`}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={8} md={6}>
          <Typography className={classes.heading}>
            {credit.title}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {credit.type === "konsum" ? "Konsumkredit" : "Hypothekarkredit"}
            {credit.subtype && " - " + capitalize(credit.subtype)}
          </Typography>
        </Grid>
        <Grid item xs={4} md={3}>
          <Typography variant="overline">
            {credit.user.name}
            {isInactiveAdvisor && (
              <span className={classes.inactiveProfileHint}>inaktives Profil</span>
            )}
          </Typography>
        </Grid>
        <Grid item xs={6} md={2}>
          {credit.status === "draft" &&
            <Button size="small" onClick={() => {
              if (userContext.user.role === "tippgeber") {
                history.push("/antrag/" + credit.id);
              } else {
                history.push("/finanzierung/" + credit.id);
              }
            }}>
              öffnen
            </Button>
          }
          {credit.status === "successful" &&
            <Tooltip title="Finanzierung wurde erfolgreich abgeschlossen" placement="top">
              <CheckCircleIcon style={{ color: green[800] }} />
            </Tooltip>
          }
          {credit.status === "archived" &&
            <Tooltip title="Finanzierung war nicht erflogreich" placement="top">
              <CancelIcon style={{ color: red[900] }} />
            </Tooltip>
          }
        </Grid>
        <Grid item xs={2} md={1}>
          <IconButton
            aria-label="more"
            aria-controls="credit-menu"
            aria-haspopup="true"
            onClick={(e) => {
              setActionsMenuTarget(e.currentTarget)
              setCreditForActions(credit)
            }}
          >
            <MoreVertIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Paper>;
  }

  if (props.credits.length === 0) {
    if (props.isArchiveView) {
      return (
        <Paper className={classes.creditRow}>
          <Typography align="center">
            Im Moment sind noch keine Finenzierungen im Archiv. Sobald du eine Finanzierung archivierst, findest du sie hier.
          </Typography>
        </Paper>
      );
    } else {
      return (
        <Paper className={classes.creditRow}>
          <Typography align="center">
            Hallo {userContext.user.name},<br />
            Diese Übersichtsseite wird all deine Finanzierungen enthalten.<br />
            Mit einem Klick auf das Logo links oben oder den Menüpunkt "Finanzierungen" rechts oben kommst du immer wieder hier her zurück.<br />
            Im Moment gibt es allerdings noch nichts zu sehen, also klick bitte rechts oben auf "Neue Finanzierung anlegen" um los zu legen.
          </Typography>
        </Paper>
      );
    }
  }
  var availableAgents = props.credits.map(credit => credit.user);
  // remove duplicates
  availableAgents = availableAgents.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
  // sort by name
  availableAgents.sort((a, b) => (a.name > b.name) ? 1 : -1);

  return (
    <div>
      <Grid
        container
        justifyContent="flex-end"
        alignItems="flex-end"
        className={classes.filterBar}
        spacing={2}>
        {["administrator", "agent"].includes(userContext.user.role) &&
          <Grid item>
            <TextField
              className={classes.searchField}
              label="Typ"
              value={typeFilter}
              onChange={(e) => {
                setTypeFilter(e.target.value);
              }}
              style={{ width: 150 }}
              select
            >
              <MenuItem key={"typefilter-empty"} value="">-</MenuItem>
              <MenuItem value="hypothekar">Hypothekarkredit</MenuItem>
              <MenuItem value="konsum">Konsumkredit</MenuItem>
            </TextField>
          </Grid>
        }
        {["administrator", "agent"].includes(userContext.user.role) && typeFilter === "hypothekar" &&
          <Grid item>
            <TextField
              className={classes.searchField}
              label="Zweck"
              value={subtypeFilter}
              onChange={(e) => {
                setSubtypeFilter(e.target.value);
              }}
              style={{ width: 150 }}
              select
            >
              <MenuItem value="">-</MenuItem>
              <MenuItem value="hauskauf">Hauskauf</MenuItem>
              <MenuItem value="wohnungskauf">Wohnungskauf</MenuItem>
              <MenuItem value="grundkauf">Grundkauf</MenuItem>
              <MenuItem value="hausbau">Hausbau</MenuItem>
              <MenuItem value="umbau">Umbau</MenuItem>
              <MenuItem value="umschuldung">Umschuldung</MenuItem>
            </TextField>
          </Grid>
        }
        {userContext.user.role === "administrator" &&
          <Grid item>
            <TextField
              className={classes.searchField}
              label="Finanzierungsberater"
              value={agentFilter}
              onChange={(e) => {
                setAgentFilter(e.target.value);
              }}
              style={{ width: 200 }}
              select
            >
              <MenuItem key={"agentfilter-empty"} value="">-</MenuItem>
              {availableAgents.map((option) => {
                return (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    disabled={option.active === false}
                    style={option.active === false ? { opacity: 0.5 } : {}}
                  >
                    {option.name}{option.active === false ? " (inaktives Profil)" : ""}
                  </MenuItem>
                )
              })}
            </TextField>
          </Grid>
        }
        {props.isArchiveView &&
          <Grid item>
            <TextField
              className={classes.searchField}
              label="Erfolg"
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
              }}
              style={{ width: 100 }}
              select
            >
              <MenuItem key={"statusfilter-empty"} value="">-</MenuItem>
              <MenuItem key={"statusfilter-successful"} value="successful">
                <CheckCircleIcon fontSize="small" style={{ color: green[800] }} />&nbsp;ja
              </MenuItem>
              <MenuItem key={"statusfilter-archived"} value="archived">
                <CancelIcon fontSize="small" style={{ color: red[900] }} />&nbsp;nein
              </MenuItem>
            </TextField>
          </Grid>
        }
        <Grid item>
          <TextField
            placeholder="Suchen"
            className={classes.searchField}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>,
            }}
          />
        </Grid>
        <Grid item xs={12}>
        </Grid>
        {props.isArchiveView && statusFilter === "successful" &&
          <Grid item>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
              <DatePicker
                variant="inline"
                openTo="year"
                margin="none"
                label="Fixzins Enddatum ab"
                format="MMMM yyyy"
                inputFormat="MMMM yyyy"
                value={fixzinsEndDateFromFilter ? fixzinsEndDateFromFilter : null}
                onChange={(value) => {
                  if (value) {
                    const d = new Date(value);
                    d.setDate(1);
                    setFixzinsEndDateFromFilter(d);
                  } else {
                    setFixzinsEndDateFromFilter(null);
                  }
                }}
                autoOk={true}
                invalidDateMessage={"ungültiges Datumsformat"}
                InputLabelProps={{
                  shrink: true,
                }}
                slotProps={{
                  textField: {
                    variant: 'standard',
                  },
                }}
                views={['year', 'month']}
              />
            </LocalizationProvider>
          </Grid>
        }
        {props.isArchiveView && statusFilter === "successful" &&
          <Grid item>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
              <DatePicker
                variant="inline"
                openTo="year"
                margin="none"
                label="Fixzins Enddatum bis"
                format="MMMM yyyy"
                inputFormat="MMMM yyyy"
                value={fixzinsEndDateToFilter ? fixzinsEndDateToFilter : null}
                onChange={(value) => {
                  if (value) {
                    const d = new Date(value);
                    d.setDate(1);
                    setFixzinsEndDateToFilter(d);
                  } else {
                    setFixzinsEndDateToFilter(null);
                  }
                }}
                autoOk={true}
                invalidDateMessage={"ungültiges Datumsformat"}
                InputLabelProps={{
                  shrink: true,
                }}
                slotProps={{
                  textField: {
                    variant: 'standard',
                  },
                }}
                views={['year', 'month']}
              />
            </LocalizationProvider>
          </Grid>
        }
        {props.isArchiveView && statusFilter === "successful" &&
          <Grid item>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ whiteSpace: 'nowrap' }}>Aufschlag variabel von</span>
              <TextField
                type="number"
                value={aufschlagVariabelFromFilter}
                onChange={(e) => {
                  setAufschlagVariabelFromFilter(e.target.value);
                }}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
                style={{ width: 100 }}
                variant="standard"
              />
              <span style={{ whiteSpace: 'nowrap' }}>bis</span>
              <TextField
                type="number"
                value={aufschlagVariabelToFilter}
                onChange={(e) => {
                  setAufschlagVariabelToFilter(e.target.value);
                }}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
                style={{ width: 100 }}
                variant="standard"
              />
            </div>
          </Grid>
        }
      </Grid>
      {
        props.credits.filter(credit => {
          if (agentFilter && credit.user.id !== agentFilter)
            return false;

          if (typeFilter && credit.type !== typeFilter)
            return false;

          if (typeFilter && credit.type === "hypothekar" && subtypeFilter && credit.subtype !== subtypeFilter)
            return false;

          if (statusFilter && credit.status !== statusFilter)
            return false;

          if (statusFilter === "successful" && (fixzinsEndDateFromFilter || fixzinsEndDateToFilter)) {
            if (!credit.stats || !credit.stats.fixzins_end_date) {
              return false;
            }

            const fixzinsEndDate = new Date(credit.stats.fixzins_end_date);

            if (fixzinsEndDateFromFilter && fixzinsEndDate < fixzinsEndDateFromFilter) {
              return false;
            }

            if (fixzinsEndDateToFilter && fixzinsEndDate > fixzinsEndDateToFilter) {
              return false;
            }
          }

          if (statusFilter === "successful" && (aufschlagVariabelFromFilter !== "" || aufschlagVariabelToFilter !== "")) {
            if (!credit.stats || credit.stats.aufschlag_variabel === undefined || credit.stats.aufschlag_variabel === null) {
              return false;
            }

            const aufschlagVariabel = parseFloat(credit.stats.aufschlag_variabel);
            const from = parseFloat(aufschlagVariabelFromFilter);
            const to = parseFloat(aufschlagVariabelToFilter);

            if (!isNaN(from) && aufschlagVariabel < from) {
              return false;
            }

            if (!isNaN(to) && aufschlagVariabel > to) {
              return false;
            }
          }

          if (searchTerm.length < 3)
            return true;

          // search in credit title and agent name first
          if (credit.title.toUpperCase()
            .includes(searchTerm.toUpperCase())
            || credit.user.name.toUpperCase()
              .includes(searchTerm.toUpperCase()))
            return true;

          // now go to metafields
          // metafields have been removed in overview for performance reasons
          // if (credit.metafields && credit.metafields.some(field => (
          //   (field.meta_key.endsWith('__vorname') || field.meta_key.endsWith('__nachname'))
          //   &&
          //   field.meta_value
          //   &&
          //   field.meta_value.toUpperCase()
          //     .includes(searchTerm.toUpperCase()
          //     )
          // )
          // )) {
          //   return true;
          // }

          // search by agent
          if (credit.user.name.toUpperCase()
            .includes(searchTerm.toUpperCase())
            || credit.user.name.toUpperCase()
              .includes(searchTerm.toUpperCase()))
            return true;

          return false;
        }).map((credit) => {
          return renderCredit(credit);
        })
      }
      <Menu
        id="credit-menu"
        anchorEl={actionsMenuTarget}
        keepMounted
        open={Boolean(actionsMenuTarget)}
        onClose={() => { setActionsMenuTarget(null) }}
      >
        {(creditForActions.status === "archived" || creditForActions.status === "successful") &&
          <MenuItem onClick={() => {
            setActionsMenuTarget(null)
            setCreditStatus("draft")
          }}>
            <ListItemIcon>
              <ArchiveIcon fontSize="small" />
            </ListItemIcon>
            <Typography variant="inherit">reaktivieren</Typography>
          </MenuItem>
        }
        {(creditForActions.status === "successful") &&
          <MenuItem onClick={() => {
            setActionsMenuTarget(null)
            setArchiveStatsOpen(true)
          }}>
            <ListItemIcon>
              <BarChartIcon fontSize="small" />
            </ListItemIcon>
            <Typography variant="inherit">Ergebnisse</Typography>
          </MenuItem>
        }
        {creditForActions.status === "draft" &&
          <MenuItem onClick={() => {
            setActionsMenuTarget(null)
            setArchiveStatsOpen(true)
            // setCreditStatus("successful")
          }}>
            <ListItemIcon>
              <CheckCircleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="erfolgreich abgeschlossen" secondary="Finanzierung archivieren" />
          </MenuItem>
        }
        {creditForActions.status === "draft" &&
          <MenuItem onClick={() => {
            setActionsMenuTarget(null)
            setCreditStatus("archived")
          }}>
            <ListItemIcon>
              <ArchiveIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="nicht erfolgreich" secondary="Finanzierung archivieren" />
          </MenuItem>
        }

        <MenuItem onClick={() => {
          setActionsMenuTarget(null)
          props.deleteCredit(creditForActions)
        }}>
          <ListItemIcon>
            <DeleteForeverIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">löschen</Typography>
        </MenuItem>
      </Menu>
      <Grid item>
        <ArchiveStatsDialog
          credit={creditForActions}
          open={archiveStatsOpen}
          setOpen={(open) => {
            setArchiveStatsOpen(open);
            if (open === false) {
              // refresh credits list on close
              props.getCredits();
            }
          }}
        />
      </Grid>
    </div>
  )
};

export default CreditsList;
